















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import ProfileInfoConfig from '@/components/Profile/config/ProfileInfoConfig.vue';
import ProfilePlatformSettings from '@/components/Profile/config/ProfilePlatformSettings.vue';
import ProfileSkillsConfig from '@/components/Profile/config/ProfileSkillsConfig.vue';
import ProfileSecurityConfig from '@/components/Profile/config/ProfileSecurityConfig.vue';
import { ChallengeModel } from '@/models/challenge.model';
import { LocaleSelectorType } from '@/store/i18n.store.module';
import Footer from '@/components/Footer.vue';
import { i18nModule, userModule } from '@/utils/store-acessor';
import { UserModel } from '@/models/user.model';

@Component({
  components: {
    ProfileSecurityConfig,
    ProfileSkillsConfig,
    ProfilePlatformSettings,
    ProfileInfoConfig,
    Footer
  }
})
export default class ProfileConfigPage extends Vue {
  @Prop({ required: false }) challenge?: ChallengeModel;
  @userModule.Getter('user') user!: UserModel;
  @i18nModule.Getter('locale') localeSelected!: LocaleSelectorType;
  tab: any | null = null;
  dialog = false;

  @Watch('localeSelected')
  asyncTranslate() {
    this.tab = undefined;
  }

  @Watch('tab')
  onTabChange(v: number) {
    if (v > 0) {
      this.requireContestant()
    }
  }

  requireContestant() {
    if (!this.user?.contestant?.id) {
      this.dialog = true;
      return;
    }
  }

}
